import { render, staticRenderFns } from "./sSelectedSector.vue?vue&type=template&id=50b3777a"
import script from "./sSelectedSector.vue?vue&type=script&lang=js"
export * from "./sSelectedSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports